<template>
    <div>
        <div class="row row-spacing">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Billing Period</label>
                    <BillingFilter
                        :baseArray="saleDefinition.sale.synaq.mailboxes"
                        @selectedOption="changeFilter"
                    />
                </div>
            </div>
        </div>
        <div class="row row-spacing">
            <div class="col-md-12">
                <table
                    class="table table-bordered"
                    v-if="filteredList.length > 0"
                >
                    <thead>
                    <tr>
                        <th>Mailbox Address</th>
                        <th>Code</th>
                        <th>Domain</th>
                        <th>
                            <TableToFile
                                small
                                fileName="Mailboxes"
                                :fieldProp="exportFields"
                                :dataProp="exportData"
                                :propDisable="filteredList.length === 0"
                            />
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="mailbox in filteredList"
                        :key="mailbox.synaqMailboxNumber"
                    >
                        <td>{{ mailbox.mailboxAddress }}</td>    
                        <td>{{ mailbox.editionCode }}</td>
                        <td>{{ saleDefinition.sale.synaq.domainName }}</td>    
                        <td></td>
                    </tr>
                    </tbody>
                </table>
                <div v-else class="alert alert-info">
                    Select billing period
                </div>

                </div>
        </div>
    </div>
</template>

<script>
import BillingFilter from "./BillingFilter";
import TableToFile from '@/components/GeneralComponents/TableToFile'

    export default {
        components: {
            BillingFilter,
            TableToFile
        },
        props: {
            saleDefinition: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                filteredList: [],
                exportFields: {
                    'Mailbox Address': 'mailboxAddress',
                    'Code': 'editionCode',
                    'Domain': 'domainName',                                        
                }
            }
        },
        computed: {
            exportData() {
                return this.filteredList.map(mailbox => ({
                    ...mailbox,
                    domainName: this.saleDefinition.sale.synaq.domainName
                }));
            },
        },
        methods: {
            changeFilter: function(data) {
                this.filteredList = data;
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>